<script setup lang="ts">
import { onMounted, watch } from 'vue';

import AppFooter from '@/components/footer/AppFooter.vue';
import AppHeader from '@/components/header/AppHeader.vue';
import { useAuthStore } from '@/features/auth/authStore';
import { useConfigStore } from '@/features/config/configStore';

const config = useConfigStore();
const auth = useAuthStore();

onMounted(() => {
  void config.fetchConfig();
  void auth.fetchIdentity();
});
watch(() => auth.user?.id, () => { void config.fetchConfig(); });
</script>

<template>
  <div v-if="!config.loaded || !auth.loaded" class="auth-loading">
    <div class="loading-spinner" aria-hidden="true"></div>
    <p>Loading…</p>
  </div>
  <template v-else>
    <AppHeader />
    <details v-if="config.cloneUrl" class="repository-access">
      <summary>Clone repository</summary>
      <input aria-label="HTTPS clone URL" :value="config.cloneUrl" readonly @focus="($event.target as HTMLInputElement).select()" />
      <p v-if="config.mode === 'local'">Use your Nori API key as the Git password. Members can fetch all branches and history, save, and publish.</p>
    </details>
    <main>
      <RouterView />
    </main>
    <AppFooter />
  </template>
</template>

<style>
.repository-access { margin: 1rem 2rem; }
.repository-access input { width: 100%; padding: .5rem; }
#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: var(--background);
}

main {
  flex: 1;
  position: relative;
}

.auth-loading {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  color: var(--muted-foreground);
}

.loading-spinner {
  width: 32px;
  height: 32px;
  border: 2px solid var(--border);
  border-top-color: var(--primary);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
